// @flow

import React from "react";
import type { Node } from "react";

import { Button, Box } from "@chakra-ui/react";
import SpinnerLoader from "src/components/Loader/SpinnerLoader";

type Props = {
  leftIcon: Node,
  onClick: Function,
  children: Node,
  isLoading?: boolean,
};

const BlueOutline = ({
  leftIcon,
  onClick,
  isLoading = false,
  children,
}: Props) => {
  if (isLoading) {
    return (
      <Button
        borderColor="unifize_blue"
        backgroundColor="unifize_brightLight"
        color="unifize_blue"
        size="xs"
        variant="outline"
        disabled
        position="relative"
      >
        {/* Just to make sure the button's dimensions don't change */}
        <span
          style={{
            visibility: "hidden",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          {leftIcon}
          {children}
        </span>
        <Box
          position="absolute"
          inset={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <SpinnerLoader size="sm" thickness={3} />
        </Box>
      </Button>
    );
  }

  return (
    <Button
      leftIcon={leftIcon}
      onClick={onClick}
      borderColor="unifize_blue"
      backgroundColor="unifize_brightLight"
      color="unifize_blue"
      size="xs"
      variant="outline"
    >
      {children}
    </Button>
  );
};

export default BlueOutline;
